import React, { Component } from "react";
import selectn from "selectn";

// import PrimaryImage from "../PrimaryImage";
import StoryContent from "../StoryContent";
import SaveTag from "../SaveTag";

import styles from "./SummaryCard.css";

class SummaryCard extends Component {
  render() {
    const story = this.props.story;
    if (!story) return null;
    const image = selectn("primary_image.crops.1x1.url", story);

    const summary = {
      ...story,
      blocks: {
        ...story.blocks,
        blocks: [story.blocks.blocks[0]],
      },
    };

    return (
      <div key={story.id} className={styles.root}>
        {this.props.showSaveTag ? <SaveTag storyId={story.id} absolute={true} /> : null}
        {image && <img className={styles.image} src={image} alt={story.primary_image.alt_text}/>}
        <StoryContent story={summary} isSummary />
      </div>
    );
  }
}

export default SummaryCard;
